import { render } from "./EditCategorieArticle.vue?vue&type=template&id=0f20becc&ts=true"
import script from "./EditCategorieArticle.vue?vue&type=script&lang=ts"
export * from "./EditCategorieArticle.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__